import { CompanyEntity } from '../common/entity';
import { EntityAuthorization } from '../common/entityAuthorization';
import { CompanyRole } from '../company_role_assignment/companyRoleAssignment';

export class Kit extends CompanyEntity {
  identifier!: string;
  templateId!: string;

  authorization = new KitAuthorization();

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
  }
}

export class KitAuthorization extends EntityAuthorization<Kit> {
  forCreate = () => CompanyRole.employee;
  forUpdate = () => CompanyRole.employee;
  forDelete = () => CompanyRole.employee;
  forGet = () => CompanyRole.employee;
}
